import React, { Component} from 'react';
import { connect } from "react-redux";
import { Form, Row, Col, Button, Modal, ModalHeader, ModalFooter, Card, CardBody, CardHeader, ModalBody, Input } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import {getPhysicalTokens, deletePhysicalToken, setPhysicalTokenPageInfo, assignPhysicalToken, unassignPhysicalToken, uploadPhysicalToken} from "../../actions/actionPhysicalTokens"
import { getAdminUsers } from "../../actions/actionAdminUser";
import Proptypes from "prop-types";
import Select from "react-select";
import { api } from '../../utils/axios';

class PhysicalToken extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            unassignModal: false,
            uploadTokenModal: false,
            deleteFileModal: false,
            confirmDeleteFileModal: false,
            filterId: null,
            addUserModal: false,
            addUserId: null,
            selectedFile: null,
            adminUsers: [],
            adminUsersFilter: null,
            adminUsersPage: 0,
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.cancelUnassign = this.cancelUnassign.bind(this);
        this.cancelFileDelete = this.cancelFileDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.unassignConfirm = this.unassignConfirm.bind(this);
        this.deletePhysicalTokenAction = this.deletePhysicalTokenAction.bind(this);
        this.unassignPhysicalTokenAction = this.unassignPhysicalTokenAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
        this.handleUploadError = this.handleUploadError.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.handleFileDropDown = this.handleFileDropDown.bind(this);
        this.toggleUploadTokenModal = this.toggleUploadTokenModal.bind(this);
        this.toggleDeleteFileModal = this.toggleDeleteFileModal.bind(this);
        this.toggleConfirmDeleteFileModal = this.toggleConfirmDeleteFileModal.bind(this);
        this.toggleModal2 = this.toggleModal2.bind(this);
        this.deleteFileAction = this.deleteFileAction.bind(this);
        this.forceDeleteFileAction = this.forceDeleteFileAction.bind(this);
        
        this.assignUserToken = this.assignUserToken.bind(this);
        this.handleFileDropDown = this.handleFileDropDown.bind(this);
        this.fireDeleteActions = this.fireDeleteActions.bind(this);
        
        this.openUserAddModal = this.openUserAddModal.bind(this);
        this.handleUserDropDown = this.handleUserDropDown.bind(this);
        this.handleAddUserSuccess = this.handleAddUserSuccess.bind(this);
        this.handleAddUserError = this.handleAddUserError.bind(this);
    }

    handleUpload(e) {
        e.preventDefault();
        this.props.uploadPhysicalToken({
            ufile: e.target.ufile.files[0],
            zippw: e.target.zippw.value
        })
        .then(() => this.handleUploadSuccess())
        .catch(() => this.handleUploadError());
    }

    componentDidMount() {
        this.props.getPhysicalTokens();
    }

    deleteConfirm(serial_number){
        this.setState({modal: !this.state.modal,
            serial_number: serial_number});
    }

    unassignConfirm(serial_number){
        this.setState({unassignModal: !this.state.unassignModal,
            serial_number: serial_number});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    cancelUnassign() {
        this.setState({ unassignModal: !this.state.unassignModal })
    }

    cancelFileDelete() {
        this.setState({ deleteFileModal: !this.state.deleteFileModal })
    }

    handleUploadSuccess(){
        const {uploadPhysicalTokenError} = this.props;
        if(uploadPhysicalTokenError) {
            NotificationManager.error(uploadPhysicalTokenError,"Upload Physical Token Failed", 3000);
        }else{
            NotificationManager.success("Successfully Uploaded Physical Token File","Upload Physical Token File", 3000);
            this.setState({uploadTokenModal: false});
            this.props.getPhysicalTokens();
        }
    }

    handleUploadError(){
        const {uploadPhysicalTokenError} = this.props;
        if(uploadPhysicalTokenError){
            NotificationManager.error(uploadPhysicalTokenError,"Failed to Upload Physical Token Config", 3000);
            this.props.history.push("/physical_tokens");
        }else{
            NotificationManager.error("Failed to Upload Token","Upload Token", 3000);
            this.props.history.push("/physical_tokens");
        }
    }


    handleDeleteSuccess(){
        const {deletePhysicalTokenErrorMessage} = this.props;
        if(deletePhysicalTokenErrorMessage) {
            NotificationManager.error(deletePhysicalTokenErrorMessage,"Delete Physical Token Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Physical Token Config","Delete Physical Token Config", 3000);
            this.setState({modal: false});
            this.setState({deleteFileModal: false});
            this.props.getPhysicalTokens();
        }
    }

    handleDeleteError(){
        const {deletePhysicalTokenError} = this.props;
        if(deletePhysicalTokenError){
            NotificationManager.error(deletePhysicalTokenError,"Failed to Delete Physical Token Config", 3000);
            this.props.history.push("/physical_tokens");
        }else{
            NotificationManager.error("Failed to Delete Token","Delete Token", 3000);
            this.props.history.push("/physical_tokens");
        }
    }

    unassignPhysicalTokenAction(){
        this.props.unassignPhysicalToken(this.state.serial_number).
        then(() => this.handleUnassignSuccess()).
        catch(() => this.handleUnassignError());
    }

    handleUnassignSuccess(){
        const {unassignPhysicalTokenErrorMessage} = this.props;
        if(unassignPhysicalTokenErrorMessage) {
            NotificationManager.error(unassignPhysicalTokenErrorMessage,"Physical Token Failed", 3000);
        }else{
            NotificationManager.success("Successfully Unassigned Physical Token Config", "Physical Token Config", 3000);
            this.setState({unassignModal: false});
            this.props.getPhysicalTokens();
        }
    }

    handleUnassignError(){
        const {unassignPhysicalTokenError} = this.props;
        if(unassignPhysicalTokenError){
            NotificationManager.error(unassignPhysicalTokenError,"Physical Token Config", 3000);
            this.props.history.push("/physical_tokens");
        }else{
            NotificationManager.error("Failed to Unassign Physical Token Config", "Physical Token Config", 3000);
            this.props.history.push("/physical_tokens");
        }
    }

    handleAddUserSuccess() {
        const { errorMessageAddUser } = this.props;
        if (errorMessageAddUser) {
            NotificationManager.error(errorMessageAddUser, "Assign Token to User", 3000);
        }
        else {
            this.setState({ addUserModal: false });
            NotificationManager.success("Successfully Assigned Token to User", "Assign Token to User", 3000);
            this.props.getPhysicalTokens()
        }
    }

    handleAddUserError() {
        const { addUserToTokenError } = this.props;
        if (addUserToTokenError) {
            NotificationManager.error(addUserToTokenError, "Assign Token to User", 3000);
        }
        else {
            this.setState({ addUserModal: false });
            NotificationManager.error("Error Assigning Token to User", "Assign Token to User", 3000);
        }
    }

    handleFileDropDown(value) {
        if (value) {
            this.setState({
                selectedFile: value.seed_filename,
            });
        } else {
            this.setState({
                selectedFile: null,
            });
        }
    }


    handleUserDropDown(value) {
        if (value) {
            this.setState({
                addUserId: value.user_id,
                adminUsers: []
            });

            this.fetchUserAdmins(0, value.username);
        } else {
            this.setState({
                addUserId: null,
                adminUsers: [],
                adminUsersFilter: null,
                adminUsersPage: 0
            });

            this.fetchUserAdmins(0);
        }
    }

    assignUserToken() {
        this.props.assignPhysicalToken({ serial_number: this.state.serial_number, user_id: this.state.addUserId }).
        then(() => this.handleAddUserSuccess()).
        catch(() => this.handleAddUserError());
    }

    deletePhysicalTokenAction(){
        const serial_or_file = { "serial_number": this.state.serial_number }
        this.fireDeleteActions(serial_or_file);
    }

    deleteFileAction() {
        const serial_or_file = { "seed_filename": this.state.selectedFile }
        const assigned_tokens = this.props.physical_tokens.map(item => item.username)
        .filter((value, index, self) => self.indexOf(value) === index) // get list of unique usernames
        .filter(n => n) // remove empty elements

        if (assigned_tokens.length > 0) {
            return this.setState({ confirmDeleteFileModal: true })
        }

        if (assigned_tokens.length === 0) {
            this.fireDeleteActions(serial_or_file)
        }
    }
    forceDeleteFileAction() {
        const serial_or_file = { "seed_filename": this.state.selectedFile }
        this.setState({ confirmDeleteFileModal: false })
        this.fireDeleteActions(serial_or_file)
    }

    fireDeleteActions(serial_or_file) {
        this.props.deletePhysicalToken(serial_or_file).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    openUserAddModal(serial) {
        this.setState({
            addUserId: null,
            adminUsers: [],
            adminUsersFilter: null,
            adminUsersPage: 0,
            addUserModal: !this.state.addUserModal,
            serial_number: serial
        });

        this.fetchUserAdmins(0);
    }

    toggleModal2() {
        this.setState({ addUserModal: !this.state.addUserModal });
    }
    toggleUploadTokenModal() {
        this.setState({ uploadTokenModal: !this.state.uploadTokenModal });
    }
    toggleDeleteFileModal() {
        this.setState({ deleteFileModal: !this.state.deleteFileModal });
    }

    toggleConfirmDeleteFileModal() {
        this.setState({ confirmDeleteFileModal: !this.state.confirmDeleteFileModal });
    }

    

    async fetchUserAdmins(page, filter = null) {
        const data = {
            page,
            page_size: 5,
            filters: [{
                id: "username",
                value: filter
            }],
            sort_by: "username",
            sort_direction: "asc"
        }

        const { users } = await api.post('admin/get_users', data);

        const allUsers = _(this.state.adminUsers || [])
            .concat(users || [])
            .uniqBy("user_id")
            .value();

        this.setState({
            adminUsers: allUsers,
            adminUsersPage: page,
            adminUsersFilter: filter
        });
    }

    render() {
        if (this.props.getPhysicalTokenLoading) {
            return (<div> <LoadingSpinner /></div>);
        }

        const loadMoreAdminUsers = () => {
            this.fetchUserAdmins(this.state.adminUsersPage + 1, this.state.adminUsersFilter);
        }

        const updateAdminUsersFilter = (value) => {
            if (value) {
                this.setState({
                    adminUsers: []
                });

                this.fetchUserAdmins(0, value);
            }
        }
        const { physical_tokens } = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Serial Name",
                accessor: "serial_number",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Seed Filename",
                accessor: "seed_filename",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "Date Imported",
                accessor: "created",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "User",
                accessor: "username",
                filterable: true,
                sortable: true,
            },
        ];

        const actions = [
            { id: "assign", icon: "fa-user-plus", description: "Assign User" },
            { id: "unassign", icon: "fa-user-times", description: "Unassign User" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "assign":
                    this.openUserAddModal(item.serial_number);
                break;
                case "unassign":
                    this.unassignConfirm(item.serial_number);
                break;
                case "delete":
                    this.deleteConfirm(item.serial_number);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-book"></i> <strong>Physical Tokens</strong></div>
                                <div>
                                    <button onClick={this.toggleUploadTokenModal} className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Import
                                    </button>
                                    <button onClick={this.toggleDeleteFileModal} className="pull-right adduser-btn" style={{ marginRight: '1rem', background: '#ff725e' }} size="sm" color="dark">
                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                    Delete Seed Series
                                    </button>
                                </div>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="physical_tokens"
                                    data={physical_tokens}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                

                <Modal isOpen={this.state.confirmDeleteFileModal} toggle={this.toggleConfirmDeleteFileModal} centered={true} className="user-modal">
                    <ModalHeader toggle={this.toggleConfirmDeleteFileModal}>WARNING: This action will delete tokens currently assigned to users. Affected users will no longer be able to use these tokens. Are you sure you want to continue?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.toggleConfirmDeleteFileModal} size="sm" 
                        className="cancel-button"
                        color=" basic"> Cancel</Button>
                        <Button onClick={this.forceDeleteFileAction} 
                        className="delete-button"
                        size="sm" color="danger">Continue</Button>
                    </ModalFooter>
                </Modal>


                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this token?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic"> Cancel</Button>
                        <Button onClick={this.deletePhysicalTokenAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.deleteFileModal} toggle={this.cancelFileDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelFileDelete}>Select a file to delete
                    </ModalHeader>
                    <ModalBody>
                    <Select
                        id="seed_filename"
                        autoFocus
                        value={this.state.selectedFile}
                        options={ [...new Map(this.props.physical_tokens.map(item => [item.seed_filename, item])).values()] }
                        valueKey="seed_filename"
                        labelKey="seed_filename"
                        name="seed_filename"
                        onChange={this.handleFileDropDown}
                    />

                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelFileDelete} size="sm" 
                        className="cancel-button"
                        color=" basic"> Cancel</Button>
                        <Button onClick={this.deleteFileAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.unassignModal} toggle={this.cancelUnassign} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelUnassign}>Are you sure you want to unassign this token?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelUnassign} size="sm" 
                        className="cancel-button"
                        color=" basic"> Cancel</Button>
                        <Button onClick={this.unassignPhysicalTokenAction} 
                        className="delete-button"
                        size="sm" color="danger">Unassign</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.uploadTokenModal} toggle={this.toggleUploadTokenModal} centered={true} className="user-modal">
                    <Form onSubmit={this.handleUpload} encType="multipart/form-data">
                    <ModalHeader toggle={this.toggleUploadTokenModal}>Upload a token file
                    </ModalHeader>
                    <ModalBody>
                        <Input type="file" name="ufile" />
                        <br />
                        Zip password
                        <Input 
                                    type="password"
                                    name="zippw" 
                                    id="zippw" 
                                /> 

                    </ModalBody>
                    <ModalFooter>
                        <Button type="submit"
                        className="delete-button"
                        size="sm" color="primary">Upload</Button>
                    </ModalFooter>
                    </Form>
                </Modal>

                <Modal isOpen={this.state.addUserModal} toggle={this.toggleModal2} centered={true} className="user-modal">
                            <ModalHeader toggle={this.toggleModal2}>Add Users</ModalHeader>
                            <ModalBody>
                                <Select
                                    id="state-select"
                                    autoFocus
                                    value={this.state.addUserId}
                                    options={this.state.adminUsers}
                                    valueKey="user_id"
                                    labelKey="username"
                                    name="selected-state"
                                    onChange={this.handleUserDropDown}
                                    onInputChange={updateAdminUsersFilter}
                                    onMenuScrollToBottom={loadMoreAdminUsers}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button onClick={this.toggleModal2} size="sm"
                                    className="cancel-button"
                                    color="basic"> Cancel</Button>
                                <Button onClick={this.assignUserToken} size="sm"
                                    className="submit-button"
                                    color="primary">  Add</Button>
                            </ModalFooter>
                        </Modal>
            </div>
        );
    }

}

PhysicalToken.propTypes = {
    unassignPhysicalToken: Proptypes.func.isRequired
};


export default connect(state => ({
        physical_tokens: state.physical_tokens.physical_tokens || [],
        getPhysicalTokenLoading: state.physical_tokens.getPhysicalTokenLoading || false,
        getPhysicalTokenErrorMessage: state.physical_tokens.getPhysicalTokenErrorMessage || false,
        getPhysicalTokenError: state.physical_tokens.getPhysicalTokenError || null,
        deletePhysicalTokenErrorMessage: state.physical_tokens.deletePhysicalTokenErrorMessage || null,
        deletePhysicalTokenError: state.physical_tokens.deletePhysicalTokenError || null,
        deletedPhysicalToken: state.physical_tokens.deletedPhysicalToken || null,
        deletePhysicalTokenLoading: state.physical_tokens.deletePhysicalTokenLoading || null,
        unassignPhysicalTokenErrorMessage: state.physical_tokens.unassignPhysicalTokenErrorMessage || null,
        unassignPhysicalTokenError: state.physical_tokens.unassignPhysicalTokenError || null,
        unassignPhysicalTokenLoading: state.physical_tokens.unassignPhysicalTokenLoading || null,
        uploadPhysicalTokenError: state.physical_tokens.uploadPhysicalTokenError || null,
        uploadPhysicalTokenLoading: state.physical_tokens.uploadPhysicalTokenLoading || null,
        
        errorMessageAddUser: state.errorMessageAddUser,
        addUserToTokenError: state.physical_tokens.addUserToTokenError,
        allusers: state.admin.users || [],
        getAdminUsers: () => dispatch(getAdminUsers()),
        pages : {pageSize : state.physical_tokens.pageSize, pageNo : state.physical_tokens.pageNo},
    }),
    dispatch => ({
        getPhysicalTokens: () => dispatch(getPhysicalTokens()),
        uploadPhysicalToken: (data) => dispatch(uploadPhysicalToken(data)),
        deletePhysicalToken: (data) => dispatch(deletePhysicalToken(data)),
        unassignPhysicalToken: (data) => dispatch(unassignPhysicalToken(data)),
        assignPhysicalToken: (data) => dispatch(assignPhysicalToken(data)),
        setPageInfo : (data)=> dispatch(setPhysicalTokenPageInfo(data)),

    }))(PhysicalToken);